// extracted by mini-css-extract-plugin
module.exports = {"brandLogoCover":"styles_brandLogoCover__RNxOx","uploadLabel":"styles_uploadLabel__3SjEM"};